"use strict";

function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.observeAuthStatus = exports.getCurrentAuthStatus = exports.redirectToLogout = exports.redirectToAuthority = exports.redirectToLogin = void 0;
var client_1 = require("../../build-babel/auth/client");
var msal_browser_1 = require("@azure/msal-browser");
var redirect_1 = require("../../build-babel/redirect");
var storage_1 = require("../../build-babel/token/storage");
var index_1 = require("../../build-babel");
var loginAttempts_1 = require("../../build-babel/utils/loginAttempts");
var session_1 = require("../../build-babel/session");
var cookieBanner_1 = require("../../build-babel/cookieBanner");
var getExtraQueryParams = function getExtraQueryParams() {
  return (0, cookieBanner_1.getCookieConsentBannerExtraQueryParam)();
};
var loginRequest = {
  scopes: []
};
var loginRedirectRequest = Object.assign(Object.assign({}, loginRequest), {
  extraQueryParameters: getExtraQueryParams()
});
// for login
var redirectToLogin = function redirectToLogin() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
    var baseUrl, serverSideSession, token;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          (0, loginAttempts_1.registerLoginAttempt)();
          if (!(0, loginAttempts_1.isLoginAttemptsLimitExceeded)()) {
            _context2.n = 2;
            break;
          }
          (0, loginAttempts_1.removeLoginAttempts)();
          _context2.n = 1;
          return (0, index_1.signOut)();
        case 1:
          return _context2.a(2);
        case 2:
          // check client and server sessions both
          baseUrl = window.location.href;
          _context2.n = 3;
          return (0, exports.getCurrentAuthStatus)();
        case 3:
          serverSideSession = _context2.v;
          if (serverSideSession) {
            _context2.n = 5;
            break;
          }
          (0, session_1.removeSession)(baseUrl, false);
          _context2.n = 4;
          return (0, client_1.get)(function (msalClient, msalRedirectResponse) {
            return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    if (msalRedirectResponse) {
                      _context.n = 1;
                      break;
                    }
                    _context.n = 1;
                    return msalClient.loginRedirect(Object.assign({}, loginRedirectRequest));
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            }));
          });
        case 4:
          _context2.n = 7;
          break;
        case 5:
          if (!(0, session_1.hasValidSession)(baseUrl)) {
            _context2.n = 6;
            break;
          }
          // user has both valid sessions - redirect next
          token = (0, storage_1.getToken)();
          token ? (0, redirect_1.redirectNext)(token) : (0, redirect_1.redirectNext)();
          _context2.n = 7;
          break;
        case 6:
          _context2.n = 7;
          return (0, index_1.signOut)();
        case 7:
          return _context2.a(2);
      }
    }, _callee2);
  }));
};
exports.redirectToLogin = redirectToLogin;
// for personal information and account settings
var redirectToAuthority = function redirectToAuthority(authority) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee4() {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return (0, client_1.get)(function (msalClient) {
            return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    _context3.n = 1;
                    return msalClient.acquireTokenRedirect(Object.assign(Object.assign({}, loginRedirectRequest), {
                      authority: authority
                    }));
                  case 1:
                    return _context3.a(2);
                }
              }, _callee3);
            }));
          });
        case 1:
          return _context4.a(2);
      }
    }, _callee4);
  }));
};
exports.redirectToAuthority = redirectToAuthority;
// for logout
var redirectToLogout = function redirectToLogout(postLogoutRedirectUri) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee6() {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          _context6.n = 1;
          return (0, client_1.get)(function (msalClient) {
            return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee5() {
              var account;
              return _regenerator().w(function (_context5) {
                while (1) switch (_context5.n) {
                  case 0:
                    account = msalClient.getActiveAccount();
                    _context5.n = 1;
                    return msalClient.logoutRedirect({
                      account: account,
                      postLogoutRedirectUri: postLogoutRedirectUri,
                      extraQueryParameters: getExtraQueryParams()
                    });
                  case 1:
                    return _context5.a(2);
                }
              }, _callee5);
            }));
          });
        case 1:
          return _context6.a(2);
      }
    }, _callee6);
  }));
};
exports.redirectToLogout = redirectToLogout;
// auth status
var getCurrentAuthStatus = function getCurrentAuthStatus() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee7() {
    var authStatus, msalClient, activeAccount, authResponse, _t;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.p = _context7.n) {
        case 0:
          authStatus = false;
          _context7.n = 1;
          return (0, client_1.getMsalClient)();
        case 1:
          msalClient = _context7.v;
          _context7.p = 2;
          activeAccount = msalClient.getActiveAccount();
          if (!activeAccount) {
            _context7.n = 4;
            break;
          }
          _context7.n = 3;
          return msalClient.acquireTokenSilent(loginRequest);
        case 3:
          authResponse = _context7.v;
          authStatus = !!authResponse.idToken;
        case 4:
          _context7.n = 6;
          break;
        case 5:
          _context7.p = 5;
          _t = _context7.v;
          // skip the error
          console.log(_t);
        case 6:
          return _context7.a(2, Promise.resolve(authStatus));
      }
    }, _callee7, null, [[2, 5]]);
  }));
};
exports.getCurrentAuthStatus = getCurrentAuthStatus;
var observeAuthStatus = function observeAuthStatus(onLoginStatusChange) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee8() {
    var LOGIN_EVENTS, LOGOUT_EVENTS, msalClient;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          LOGIN_EVENTS = [msal_browser_1.EventType.LOGIN_SUCCESS, msal_browser_1.EventType.ACCOUNT_ADDED];
          LOGOUT_EVENTS = [msal_browser_1.EventType.LOGOUT_SUCCESS, msal_browser_1.EventType.ACCOUNT_REMOVED];
          _context8.n = 1;
          return (0, client_1.get)();
        case 1:
          msalClient = _context8.v;
          msalClient.addEventCallback(function (message) {
            if (LOGIN_EVENTS.includes(message.eventType)) {
              onLoginStatusChange(true);
            }
            if (LOGOUT_EVENTS.includes(message.eventType)) {
              onLoginStatusChange(false);
            }
          });
        case 2:
          return _context8.a(2);
      }
    }, _callee8);
  }));
};
exports.observeAuthStatus = observeAuthStatus;
//# sourceMappingURL=index.js.map